import { render, staticRenderFns } from "./positionView.vue?vue&type=template&id=acadd54e&scoped=true&"
import script from "./positionView.vue?vue&type=script&lang=js&"
export * from "./positionView.vue?vue&type=script&lang=js&"
import style0 from "./positionView.vue?vue&type=style&index=0&id=acadd54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acadd54e",
  null
  
)

export default component.exports